<script setup lang="ts">
import { RouterView } from 'vue-router';
import { coverVisible } from '@/update/sw-update';
</script>

<template>
  <RouterView />
  <!-- Black over everything for the moment a reload takes: the screen goes
       dark and comes back, rather than flashing a half-torn-down page. -->
  <Transition name="reload-cover">
    <div v-if="coverVisible" class="reload-cover" aria-hidden="true" />
  </Transition>
</template>

<style scoped>
:deep(*) {
  box-sizing: border-box;
}
.reload-cover {
  position: fixed;
  inset: 0;
  background: #000;
  /* Above everything: the stage fences zone z-index with `isolation`, and the
     signal banner and diagnostics overlay sit at single digits outside it. */
  z-index: 2147483647;
  pointer-events: none;
}
.reload-cover-enter-active {
  transition: opacity 300ms ease;
}
.reload-cover-enter-from {
  opacity: 0;
}
</style>
